import { c as _c } from "react/compiler-runtime";
import { IcoFileText224, IcoKey24 } from '@onefootprint/icons';
import { Divider, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
import UploadFile from '../upload-file';
const ClientIdentity = t0 => {
  const $ = _c(62);
  const {
    id,
    onSubmit,
    values
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create.form.clientIdentity"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== values.clientIdentity) {
    t2 = {
      defaultValues: {
        clientIdentity: values.clientIdentity
      }
    };
    $[1] = values.clientIdentity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const form = useForm(t2);
  let t3;
  if ($[3] !== form || $[4] !== t) {
    t3 = value => {
      const key = form.getValues("clientIdentity.key");
      if (key && !value) {
        return t(_temp);
      }
      return true;
    };
    $[3] = form;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const validateCertificate = t3;
  let t4;
  if ($[6] !== form || $[7] !== t) {
    t4 = value_0 => {
      const certificate = form.getValues("clientIdentity.certificate");
      if (certificate && !value_0) {
        return t(_temp2);
      }
      return true;
    };
    $[6] = form;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const validateKey = t4;
  let t5;
  if ($[9] !== form || $[10] !== onSubmit) {
    t5 = form.handleSubmit(onSubmit);
    $[9] = form;
    $[10] = onSubmit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp3);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <span className="mb-4 text-label-2 text-primary">{t6}</span>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp4);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp5);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== form) {
    t10 = value_1 => {
      form.setValue("clientIdentity.certificate", value_1);
      form.trigger("clientIdentity.key");
    };
    $[20] = form;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(_temp6);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== validateCertificate) {
    t12 = {
      validate: validateCertificate
    };
    $[24] = validateCertificate;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <Form.Textarea size="compact" name="clientIdentity.certificate" autoFocus={true} placeholder={t11} id="certificate" rules={t12} />;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t13 || $[31] !== t8 || $[32] !== t9) {
    t14 = <UploadFile accept=".pem, .crt" cta={t8} iconComponent={IcoFileText224} id="certificate" label={t9} onChange={t10}>{t13}</UploadFile>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t8;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="my-6"><Divider /></div>;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t(_temp7);
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t(_temp8);
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== form) {
    t18 = value_2 => {
      form.setValue("clientIdentity.key", value_2);
      form.trigger("clientIdentity.certificate");
    };
    $[39] = form;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t(_temp9);
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== validateKey) {
    t20 = {
      validate: validateKey
    };
    $[43] = validateKey;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <Form.Textarea size="compact" name="clientIdentity.key" placeholder={t19} id="key" rules={t20} />;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t16 || $[49] !== t17 || $[50] !== t18 || $[51] !== t21) {
    t22 = <UploadFile accept=".key" cta={t16} iconComponent={IcoKey24} id="key" label={t17} onChange={t18}>{t21}</UploadFile>;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== id || $[54] !== t14 || $[55] !== t22 || $[56] !== t5 || $[57] !== t7) {
    t23 = <form id={id} onSubmit={t5}>{t7}{t14}{t15}{t22}</form>;
    $[53] = id;
    $[54] = t14;
    $[55] = t22;
    $[56] = t5;
    $[57] = t7;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== form || $[60] !== t23) {
    t24 = <FormProvider {...form}>{t23}</FormProvider>;
    $[59] = form;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  return t24;
};
export default ClientIdentity;
function _temp($) {
  return $.errors.certificateRequired;
}
function _temp2($_0) {
  return $_0.errors.keyRequired;
}
function _temp3($_1) {
  return $_1.title;
}
function _temp4($_2) {
  return $_2.certificate.cta;
}
function _temp5($_3) {
  return $_3.certificate.label;
}
function _temp6($_4) {
  return $_4.certificate.placeholder;
}
function _temp7($_5) {
  return $_5.key.cta;
}
function _temp8($_6) {
  return $_6.key.label;
}
function _temp9($_7) {
  return $_7.key.placeholder;
}